export const REGULAR_PUZZLE_TYPE = 'regularPuzzleType'
export const MISSING_PUZZLE_TYPE = 'missingPuzzleType'
export const MAXIMUM_PUZZLE_TYPE = 'maximumPuzzleType'

